(function(window, document, $){
  'use strict';
  if (!$ || typeof $.jGrowl === 'function') return;

  function ensureStyles(){
    if (document.getElementById('ice-jgrowl-compat-css')) return;
    var style = document.createElement('style');
    style.id = 'ice-jgrowl-compat-css';
    style.textContent = '.jGrowl{position:fixed;z-index:99999;max-width:420px;box-sizing:border-box}.jGrowl.ice-center{top:50%;left:50%;transform:translate(-50%,-50%)}.jGrowl.ice-top-right{top:20px;right:20px}.jGrowl-notification{box-sizing:border-box;cursor:pointer;margin:0 0 10px;padding:14px 18px;border-radius:3px;background:rgba(30,30,30,.94);color:#fff;box-shadow:0 8px 24px rgba(0,0,0,.2)}';
    document.head.appendChild(style);
  }

  function getContainer(position){
    ensureStyles();
    var key = position === 'center' ? 'center' : 'top-right';
    var id = 'ice-jgrowl-' + key;
    var container = document.getElementById(id);
    if (!container) {
      container = document.createElement('div');
      container.id = id;
      container.className = 'jGrowl ice-' + key;
      document.body.appendChild(container);
    }
    return container;
  }

  $.jGrowl = function(message, options){
    options = options || {};
    var container = getContainer(options.position);
    var notice = document.createElement('div');
    notice.className = 'jGrowl-notification';
    notice.setAttribute('role', 'alert');
    notice.innerHTML = message == null ? '' : String(message);
    container.appendChild(notice);

    var removed = false;
    function remove(){
      if (removed) return;
      removed = true;
      if (notice.parentNode) notice.parentNode.removeChild(notice);
      if (!container.children.length && container.parentNode) container.parentNode.removeChild(container);
    }

    notice.addEventListener('click', remove);
    window.setTimeout(remove, Math.max(0, parseInt(options.life, 10) || 3000));
    return notice;
  };
}(window, document, window.jQuery));
